import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type UserState = {
  dataAppUser: AppUserType[];
};

export const userInitialState: UserState = {
  dataAppUser: [],
};

export const slice = createSlice({
  name: 'user',
  initialState: userInitialState,
  reducers: {
    setAppUserAction(state, { payload }: PayloadAction<{ dataAppUser: AppUserType[] }>) {
      state.dataAppUser = payload.dataAppUser;
    },
  },
});

export const { setAppUserAction } = slice.actions;

export default slice.reducer;
